import moment from "moment";
import { getFormList } from "../forms/forms";
import { getFieldText } from "../../scripts/helperScripts";

export default function getCompliancy(config, clientProgram, history) {
  let compliant = {};
  if (config) {
    const compliancyConfig = config;
    compliancyConfig.forEach((cform) => {
      if (
        cform.initial.event !== "Discharge" ||
        (cform.initial.event === "Discharge" && clientProgram.ccx_dischargedate)
      ) {
        //SET FORMSY INFO BASED ON FORM NAME
        compliant[cform.formId] = {};
        const formLink = getFormList(cform.form, []);
        compliant[cform.formId].rules = cform;
        compliant[cform.formId].path = formLink.formPath;
        compliant[cform.formId].name = formLink.formName;
        compliant[cform.formId].formId = formLink.formId;
        compliant[cform.formId].formVersion = formLink.formVersionId;
        compliant[cform.formId].versionNumber = formLink.formVersionNumber;
        compliant[cform.formId].window = parseInt(cform.initial.window);
        compliant[cform.formId].implemented = cform.implemented;

        //FILTER FORMSY SUBMISSIONS FOR FORMID
        let formHistory = history.filter(
          (h) =>
            cform.formId === h.FormId &&
            h.Active === "1" &&
            h.FinalSigned === "1"
        );

        //CHECK IF CLIENT PROGRAM ADMIT DATE IS AFTER FORM IMPLEMENTED DATE
        const implementedBeforeAdmission =
          new Date(cform.implemented) <
          new Date(
            clientProgram.ccx_admitdate && clientProgram.ccx_admitdate["#text"]
              ? clientProgram.ccx_admitdate["#text"]
              : "1999-12-31T00:00:00.000Z"
          );

        //CHECK CONFIG FOR FILTER AND APPLY

        // This was incorrectly filtering the history to only records that included "initial"
        // implemented initialRequirementsMet instead

        // if (implementedBeforeAdmission && cform.initial?.filter) {
        //   const filterString = JSON.stringify(cform.initial.filter);
        //   formHistory = formHistory.filter((h) =>
        //     h.CompliancyConfiguration?.includes(filterString)
        //   );
        // }
        let initialRequirementMet =
          implementedBeforeAdmission && cform.initial?.filter
            ? formHistory.filter((h) =>
                h.CompliancyConfiguration?.includes(
                  JSON.stringify(cform.initial?.filter)
                )
              ).length > 0
            : formHistory.length > 0;

        //INITIAL DUE WILL BE BASED ON CLIENT PROGRAM ADMIT DATE
        //OR DEFAULT TO FORM IMPLEMENTED DATE + SUBSEQUENT DAYS or INITIAL DAYS
        const initialDue = implementedBeforeAdmission
          ? moment(getFieldText(clientProgram.ccx_admitdate)).add(
              cform.initial.days,
              "days"
            )
          : moment(cform.implemented).add(
              cform.subsequent ? cform.subsequent.days : cform.initial.days,
              "days"
            );

        //IF NO HISTORY SET FIRST DUE
        if (formHistory.length === 0) {
          compliant[cform.formId].history = [
            {
              compliant: "Not Done",
              days: moment().diff(
                moment(
                  clientProgram.ccx_admitdate &&
                    clientProgram.ccx_admitdate["#text"]
                    ? clientProgram.ccx_admitdate["#text"]
                    : "1999-12-31T00:00:00.000Z"
                ),
                "days"
              ),
              dueString: `${initialDue.format("MM/DD/YYYY")}   ( ${
                implementedBeforeAdmission
                  ? cform.initial.days
                  : cform.subsequent.days
              } )`,
              dateSigned: null,
              dueDate: initialDue.format("MM/DD/YYYY"),
              submissionId: null,
              window: cform.initial.window,
            },
          ];
        } else {
          //PROCESS EACH FORMSY SUBMISSION HISTORY
          compliant[cform.formId].history = [];
          let nextDue = initialDue;
          formHistory.forEach((item, index) => {
            //First record in submission history is due on the initialDue date
            //subsequent records are do based on previous final signed dates
            const due =
              index === 0
                ? initialDue
                : cform.subsequent
                ? moment(formHistory[index - 1].FinalSignedDate).add(
                    cform.subsequent.days,
                    "days"
                  )
                : null;
            nextDue = cform.subsequent
              ? moment(formHistory[index].FinalSignedDate).add(
                  cform.subsequent.days,
                  "days"
                )
              : null;

            //PUSH COMPLIANCY INFO FOR EACH FORM BASED ON CALCULATIONS
            compliant[cform.formId].history.push({
              compliant:
                index === 0
                  ? initialRequirementMet === true
                    ? due.diff(moment(item.FinalSignedDate), "days") > -1
                      ? "On Time"
                      : "Late"
                    : "Initial Form Not Done"
                  : due.diff(moment(item.FinalSignedDate), "days") > -1
                  ? "On Time"
                  : "Late",
              days:
                index === 0
                  ? moment(item.FinalSignedDate).diff(
                      moment(
                        implementedBeforeAdmission
                          ? getFieldText(clientProgram.ccx_admitdate)
                          : cform.implemented
                      ),
                      "days"
                    )
                  : moment(item.FinalSignedDate).diff(
                      moment(formHistory[index - 1].FinalSignedDate),
                      "days"
                    ),
              dueString:
                due !== null
                  ? `${due.format("MM/DD/YYYY")}   ( ${
                      index === 0
                        ? implementedBeforeAdmission
                          ? cform.initial.days
                          : cform.subsequent.days
                        : cform.subsequent.days
                    } )`
                  : null,
              dueDate: nextDue,
              window: cform.subsequent.window,
              dateSigned: moment(item.FinalSignedDate).format("MM/DD/YYYY"),
              submissionId: item.SubmissionId,
            });
          });

          //compliant: `Due In ${nextDue.diff(moment(), "days")} days`,

          //CHECK IF CLIENT PROGRAM IS DISCHARGED
          //IF DISCHARGED DO NOT ADD FUTURE DUE FOR REGULAR SUBMISSION
          if (clientProgram.ccx_dischargedate) {
            //CHECK IF CONFIG CONTAINS CRITERIA FOR DISCHARGE FORM DUE
            if (cform.discharge) {
              const filterString = cform.discharge.filter
                ? JSON.stringify(cform.discharge.filter)
                : "";
              const due = moment(
                getFieldText(clientProgram.ccx_dischargedate)
              ).add(cform.discharge.days, "days");

              //GET HISTORY OF DISCHARGE FORMS
              let dischargeHistory = history.filter(
                (h) =>
                  cform.formId === h.FormId &&
                  h.Active === "1" &&
                  h.FinalSigned === "1" &&
                  h.CompliancyConfiguration?.includes(filterString)
              );

              //IF THERE ARE DISCHARGE SUBMISSIONS SHOW COMPLIANCY
              if (dischargeHistory.length > 0) {
                dischargeHistory.forEach((dh) => {
                  compliant[cform.formId].history.push({
                    compliant:
                      due.diff(moment(dh.FinalSignedDate), "days") > 0
                        ? "Discharge Form On Time"
                        : "Discharge Form Late",
                    days: moment(clientProgram.ccx_dischargedate).diff(
                      moment(dh.FinalSignedDate),
                      "days"
                    ),
                    dueString: due,
                    dueDate: due,
                    window: cform.discharge.window,
                    dateSigned: moment(dh.FinalSignedDate).format("MM/DD/YYYY"),
                    submissionId: dh.SubmissionId,
                  });
                });
              } else {
                //IF THERE ARE NO DISCHARGE SUBMSSIONS ADD A DUE RECORD
                compliant[cform.formId].history.push({
                  compliant: "Not Done",
                  days: null,
                  dueString: `Discharge form due ${due.format("MM/DD/YYYY")} (${
                    cform.discharge.window
                  })`,
                  dueDate: due,
                  window: cform.discharge.window,
                  dateSigned: null,
                  submissionId: null,
                });
              }
            }
          }

          //IF CLIENT PROGRAM IS NOT DISCHARGE, ADD DUE RECORDS BASED ON DUE OR PAST DUE
          else if (nextDue && moment().isBefore(nextDue)) {
            compliant[cform.formId].history.push({
              compliant: "Not Done",
              days: null,
              dueString: `${nextDue.format("MM/DD/YYYY")}   ( ${
                cform.subsequent.days
              } )`,
              dueDate: nextDue,
              window: cform.subsequent.window,
              dateSigned: null,
              submissionId: null,
            });
          } else if (nextDue && moment().isAfter(nextDue)) {
            compliant[cform.formId].history.push({
              compliant: "Past Due",
              days: `${moment().diff(nextDue, "days")} days`,
              dueString: `${nextDue.format("MM/DD/YYYY")}   ( ${
                cform.subsequent.days
              } )`,
              dueDate: nextDue,
              window: cform.subsequent.window,
              dateSigned: null,
              submissionId: null,
            });
          }
        }
      }
    });
  }

  console.log("Compliant: ", compliant);
  return compliant;
}

export function getCompliancyNextDue(config, clientProgram, history) {
  let compliant = [];
  if (config) {
    const compliancyConfig = config;
    compliancyConfig.forEach((cform) => {
      if (
        cform.initial.event !== "Discharge" ||
        (cform.initial.event === "Discharge" && clientProgram.ccx_dischargedate)
      ) {
        const formLink = getFormList(cform.form, []);

        //FILTER FORMSY SUBMISSIONS FOR FORMID
        let formHistory = history.filter(
          (h) =>
            cform.formId === h.FormId &&
            h.Active === "1" &&
            h.FinalSigned === "1"
        );

        //CHECK IF CLIENT PROGRAM ADMIT DATE IS AFTER FORM IMPLEMENTED DATE
        const implementedBeforeAdmission =
          new Date(cform.implemented) <
          new Date(clientProgram.ccx_admitdate["#text"]);

        //CHECK CONFIG FOR FILTER AND APPLY
        // if (implementedBeforeAdmission && cform.initial?.filter) {
        //   const filterString = JSON.stringify(cform.initial.filter);
        //   formHistory = formHistory.filter((h) =>
        //     h.CompliancyConfiguration?.includes(filterString)
        //   );
        // }

        //INITIAL DUE WILL BE BASED ON CLIENT PROGRAM ADMIT DATE
        //OR DEFAULT TO FORM IMPLEMENTED DATE + SUBSEQUENT DAYS or INITIAL DAYS
        const initialDue = implementedBeforeAdmission
          ? moment(getFieldText(clientProgram.ccx_admitdate)).add(
              cform.initial.days,
              "days"
            )
          : moment(cform.implemented).add(
              cform.subsequent ? cform.subsequent.days : cform.initial.days,
              "days"
            );

        let obj = {
          name: formLink.formName,
          client: clientProgram.ccx_patient,
          clientProgram: clientProgram,
          formId: formLink.formId,
          formVersionId: formLink.formVersionId,
          formVersionNumber: formLink.formVersionNumber,
          path: formLink.formPath,
          implemented: cform.implemented,
          rules: cform,
        };

        //IF DISCHARGED AND CONFIG CONTAINS DISCHARGE CRITERIA
        if (clientProgram.ccx_dischargedate && cform.discharge) {
          const due = moment(getFieldText(clientProgram.ccx_dischargedate)).add(
            cform.discharge.days,
            "days"
          );

          formHistory = formHistory.filter(
            (h) =>
              h.CompliancyConfiguration &&
              h.CompliancyConfiguration.includes(
                JSON.stringify(cform.discharge.filter)
              )
          );

          if (formHistory.length === 0) {
            obj.due = due.format("MM/DD/YYYY");
            obj.type = "discharge";
            compliant.push(obj);
          }
        }

        //IF NO HISTORY SET FIRST DUE BASED ON ADMIT DATE AND IMPLEMENTED DATE
        else if (formHistory.length === 0) {
          obj.due = initialDue.format("MM/DD/YYYY");
          obj.type = "initial";
          compliant.push(obj);
        }

        //IF THERE IS HISTORY SET NEXT DUE BASED ON SUBMISSION HISTORY
        else if (formHistory.length > 0 && cform.subsequent) {
          obj.due = moment(formHistory[formHistory.length - 1].FinalSignedDate)
            .add(cform.subsequent.days, "days")
            .format("MM/DD/YYYY");
          obj.type = "subsequent";
          compliant.push(obj);
        }
      }
    });

    return compliant;
  }
}
